import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TableModule } from 'primeng/table';
import { TramSeguimientoService } from '../../../../../services/database/tramSeguimiento.service';
import { IGetTramSeguimientos } from '../../../../../shared/interfaces/database/tramite';
import { LocalService, DataColumnType, CustomTableComponent, ICustomTable, ButtonColumnType,DATE_WITH_HOUR_FORMAT } from 'lib-base';
import { ButtonModule } from 'primeng/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import { SeguimientoDocumentosComponent } from './seguimiento-documentos/seguimiento-documentos.component';

@Component({
  selector: 'app-seguimientos-historial',
  standalone: true,
  imports: [
    CommonModule, TranslateModule, CustomTableComponent,
    TableModule, ButtonModule, SeguimientoDocumentosComponent,

  ],
  template:`
<custom-table [config]="customTable" [rowExpansionTemplate]="tableRowexpansion" styleClass="p-datatable-sm p-datatable-gridlines">
</custom-table>

<ng-template #tableRowexpansion let-data>
    <app-seguimiento-documentos [tramSeguimiento]="data"
                                class="app-card mx-auto border-1 border-top-none border-noround-top"/>
</ng-template>
  `
})
export class SeguimientosHistorialComponent implements OnInit {
  @Input() actividadId!: number;

  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;

  constructor(private readonly _ts: TramSeguimientoService,  public readonly ls: LocalService, private readonly _t: TranslateService) {
  }

  ngOnInit(): void {
    this.translate().then(() => {
      this.configureTable();
    });
    this.getTramSeguimientos();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      seguimientos: this._t.get('common.seguimientos'),
      seguimiento: this._t.get('common.seguimiento'),
      fechaSeguimiento: this._t.get('common.fechaSeguimiento'),
      creadoPorUsuario: this._t.get('common.creadoPorUsuario')
    }));
  }

  private configureTable() {
    this.customTable = {
      columns: [
        {
          field: 'expand',
          header: '',
          class:'p-button-info',
          width: '0.5rem',
          buttonType: ButtonColumnType.EXPANDED
        },
        {
          field: 'comentario',
          header: this.trans.seguimiento,
          sort: false,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'fechaSeguimiento',
          header: this.trans.fechaSeguimiento,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          format:DATE_WITH_HOUR_FORMAT,
          dataType: DataColumnType.DATE
        },
        {
          field: 'creadoPorUsuario',
          header: this.trans.creadoPorUsuario,
          sort: false,
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          dataType: DataColumnType.CHECK
        }
      ]
    } as ICustomTable;
  }

  getTramSeguimientos() {
    if (!this.actividadId) return;
    this._ts.getTramSeguimientos(this.actividadId).subscribe({
      next: (data: IGetTramSeguimientos[]) => {
        this.customTableComponent.data = data;
        const lastRow = data[data.length - 1];
        if (lastRow) {
          this.customTableComponent.expandedRowKeys = { [lastRow.id]: true };
        }
      }
    });
  }


}
